export function createPolygonLayer (layerName: string, paint: any, overrides?: ReturnType<any>) {
    return {
        id: `${layerName}`,
        source: layerName,
        type: 'fill',
        interactive: true,
        layout: {
            visibility: 'none'
        },
        paint: {
            "fill-color": "#fbdada",
            "fill-outline-color": "#a9392f",
            "fill-opacity": ["case",
                ["boolean", ["feature-state", "hover"], false],
                1,
                0.5
            ],
            // "fill-opacity": 0.5,
            ...paint
        },
        ...overrides
    };
}
